// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/views/pendingDeletion/index.css
// module id = 2031
// module chunks = 0